import { apiClient } from 'pobble-components/dist/api'
import finished from './illustrations/parents-child.png'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import injectSheet from 'react-jss'
import { Image } from 'pobble-components/dist/image'
import Button from 'pobble-components/dist/button'
import { Modal, ModalContent, ModalFooter } from 'pobble-components/dist/modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-regular-svg-icons/faStar'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { useHistory, useParams } from 'react-router-dom'
import { Presentation } from 'pobble-components/dist/presentation'
import PrintModal from '../../print-modal/print-modal'
import ButtonElement from 'pobble-components/dist/button-element'
import { toast } from 'pobble-components/dist/toast'
import { useMemo } from 'react'
import {
  daysOfWeek,
  getWeekday,
  months,
  YEAR
} from '../prompt/calendar/calendar.helpers'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import builder from '../prompt/builder.jpg'
import { UpsellModal } from '../prompt/upsell'
import { PromptsLayout } from '../../prompts-layout'
import { ShareModal } from '../../share/share'
import { faFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt'
import { faPencil } from '@fortawesome/pro-regular-svg-icons/faPencil'
import { faCamera } from '@fortawesome/pro-regular-svg-icons/faCamera'
import { useWritingPack, WritingPackModal } from '../../share/writing-pack'
import { SlidesDeck } from '../../slides-deck/slides-deck'
import {
  Controls,
  createStateFromHtml,
  Editor,
  EditorProvider,
  EditorState,
  stateToHTML
} from '../../editor'
import classNames from 'classnames'
import useFreePrompts from '../../../common/utils'
import posthog from 'posthog-js'
import { useMe } from 'pobble-components/dist/pobble-user'
import wiggleBorder from '../prompt/wiggle-border.png'
import { useDifficultyLevels } from '../prompt/differentiation'
import PresentationControls from '../../presentation-controls/presentation-controls'
import { usePresentMode } from '../../pages/direct-present/present-mode'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getErrorInfo } from 'pobble-components/dist/utils'
import {
  PARENT_HERO_GRADIENT_BOTTOM,
  PARENT_HERO_GRADIENT_TOP,
  PARENT_PAGE_BG,
  PARENT_PRIMARY_CTA,
  PARENT_STICKY_HEADER_BG
} from './parent-theme'
import { ParentWritingDoneWizard } from './parent-writing-done-wizard'
import { ParentBackToWriting } from './parent-back-to-writing'
import { ParentHowToUsePanel } from './parent-how-to-use-panel'
import { useParentWriting } from './use-parent-writing'

const DEFAULT_INCLUDE =
  'presentation.audio,presentation.p365,presentation.account,presentation.category,presentation.status,presentation.image,presentation.year_groups,presentation.details,presentation.slides,presentation.slide.type,presentation.slide.details,presentation.names'

const getTypedBodyFromWorkVersion = workVersion => {
  if (!workVersion) return ''

  if (typeof workVersion.typed_body_cache === 'string') {
    return workVersion.typed_body_cache
  }

  if (typeof workVersion.typed_body === 'string') {
    return workVersion.typed_body
  }

  if (!workVersion.work || !workVersion.work.medium) return ''

  const details = workVersion.work.medium.details

  if (typeof details === 'string') return details
  if (details && typeof details.body === 'string') return details.body
  if (details && typeof details.value === 'string') return details.value

  return ''
}

const hasMeaningfulBody = html =>
  !!(
    html &&
    html
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim()
  )

const EditUpsell = props => {
  return (
    <UpsellModal
      id="edit"
      ctaLink="/account/membership?from=edit#tiers-individuals"
      ctaClassName="metrics__subscription_modal--edit"
      {...props}>
      <h2>Get access to the Pobble Builder</h2>
      <img
        width="1207"
        height="704"
        src={builder}
        alt="Entire calendar unlocked"
      />
      <p>
        Use the Pobble Builder to edit existing activites or add new activities
        such as <strong>work exemplar</strong>, <strong>word bank</strong> or{' '}
        <strong>grammar exercise</strong>.
      </p>
    </UpsellModal>
  )
}

const SvgScrollArrow = props => (
  <svg {...props} viewBox="0 0 1792 1792">
    <path d="M1675 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37L155 922q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294V256q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z" />
  </svg>
)

const SVGLeftArrow = props => (
  <svg viewBox="0 0 1792 1792" {...props}>
    <path d="M1203 544q0 13-10 23L800 960l393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10L631 983q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z" />
  </svg>
)

const SVGRightArrow = props => (
  <svg viewBox="0 0 1792 1792" {...props}>
    <path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z" />
  </svg>
)

const HeroHeader = injectSheet({
  heroHeader: {
    position: 'sticky',
    display: 'flex',
    top: '0',
    zIndex: '40',
    width: '100%',
    opacity: '0',
    pointerEvents: 'none',
    background: PARENT_HERO_GRADIENT_TOP,
    '@media (min-width: 768px)': {
      height: '80px'
    }
  },
  scrolledPastHero: {
    background: PARENT_STICKY_HEADER_BG,
    opacity: '1',
    pointerEvents: 'auto',
    boxShadow: '0 4px 16px rgba(129, 95, 165, 0.15)'
  }
})(({ children, classes }) => {
  const [scrolledPastHero, setScrolledPastHero] = useState(false)

  useEffect(
    () => {
      const listener = () => {
        if (window.pageYOffset - window.innerHeight > 200) {
          if (!scrolledPastHero) setScrolledPastHero(true)
        } else {
          if (scrolledPastHero) {
            setScrolledPastHero(false)
          }
        }
      }
      window.addEventListener('scroll', listener)
      return () => {
        window.removeEventListener('scroll', listener)
      }
    },
    [scrolledPastHero]
  )

  return (
    <header
      className={`${classes.heroHeader} ${scrolledPastHero &&
        classes.scrolledPastHero}`}>
      {children({ scrolledPastHero })}
    </header>
  )
})

const Nav = injectSheet({
  button: {
    position: 'absolute',
    top: 'calc(50vh - 80px)',
    left: '0',
    zIndex: '20',
    opacity: '0',
    transform: 'translateX(8px)',
    animation: '.5s appear .2s ease-out forwards',
    '& svg': {
      width: '72px',
      height: '80px',
      fill: 'rgba(255, 255, 255, .6)',
      stroke: '#000',
      strokeWidth: '4px',
      strokeOpacity: '.5'
    },
    '&:hover': {
      '& svg': {
        fill: 'rgba(255, 255, 255, 1)'
      },
      '& img': {
        opacity: 1
      }
    }
  },
  buttonNext: {
    left: 'auto',
    right: '0',
    transform: 'translateX(-8px)'
  },
  '@keyframes appear': {
    to: {
      transform: 'translateY(0)',
      opacity: '1'
    }
  },
  adjacentThumbWrapper: {
    position: 'relative',
    opacity: 0,
    transition: '400ms ease-out opacity 200ms',
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'inline-block'
    },
    '& span': {
      position: 'absolute',
      color: '#333',
      fontWeight: 'bold',
      zIndex: '10',
      opacity: '0.8',
      bottom: '10px',
      left: '6px',
      fontSize: '9px',
      background: '#fff',
      borderRadius: '2px',
      textTransform: 'uppercase',
      padding: '0px 4px'
    }
  },
  adjacentThumb: {
    display: 'inline-block',
    border: '2px solid #fff',
    borderRadius: '8px',
    opacity: '0.7',
    position: 'relative',
    width: '120px',
    height: '69px'
  },
  adjacentNextLabel: {
    right: '6px',
    left: 'auto !important'
  },
  thumbLoaded: {
    opacity: '1'
  }
})(({ classes, className, presentation }) => {
  const [adjacentPresentations, setAdjacentPresentations] = useState(null)

  const history = useHistory()

  useEffect(
    () => {
      setAdjacentPresentations(null)
      if (presentation) {
        apiClient
          .get(`/v3/p365/${presentation.id}`, {
            params: {
              count: 3,
              from: 0,
              include: 'presentation.image'
            }
          })
          .then(res =>
            setAdjacentPresentations({
              prev: res.data.presentations[0].id,
              next: res.data.presentations[2].id,
              prevThumb:
                res.data.presentations[0].image &&
                res.data.presentations[0].image.thumb_url,
              nextThumb:
                res.data.presentations[0].image &&
                res.data.presentations[2].image.thumb_url
            })
          )
          .catch(e => undefined)
      }
    },
    [presentation]
  )

  const [loaded, setLoaded] = useState(false)

  return !presentation || !presentation.p365 ? null : (
    <>
      <ButtonElement
        onClick={() => {
          apiClient.post('/v3/me/activated_with_product', {
            type: 'content'
          })
          posthog.capture('activate', { type: 'content' })
          posthog.capture('click on navigation button on prompt', {
            direction: 'prev'
          })
          adjacentPresentations &&
            history.push(`/parent/lesson/${adjacentPresentations.prev}`)
        }}
        className={`${classes.button} ${
          classes.buttonPrev
        } metrics__prompt_prev`}>
        <SVGLeftArrow />
        {adjacentPresentations && (
          <div
            className={`${classes.adjacentThumbWrapper} ${className} ${
              loaded ? classes.thumbLoaded : ''
            }`}>
            <span>Yesterday</span>
            <Image
              className={`${classes.adjacentThumb}`}
              src={adjacentPresentations.prevThumb}
              alt={"Yesterday's lesson"}
              onLoad={() => setLoaded(true)}
            />
          </div>
        )}
      </ButtonElement>
      <ButtonElement
        onClick={() => {
          apiClient.post('/v3/me/activated_with_product', {
            type: 'content'
          })
          posthog.capture('activate', { type: 'content' })
          posthog.capture('click on navigation button on prompt', {
            direction: 'next'
          })
          adjacentPresentations &&
            history.push(`/parent/lesson/${adjacentPresentations.next}`)
        }}
        className={`${classes.button} ${
          classes.buttonNext
        } metrics__prompt_prev`}>
        {adjacentPresentations && (
          <div
            className={`${classes.adjacentThumbWrapper} ${className} ${
              loaded ? classes.thumbLoaded : ''
            }`}>
            <span className={classes.adjacentNextLabel}>Tomorrow</span>
            <Image
              className={`${classes.adjacentThumb} ${
                classes.adjacentThumbNext
              }`}
              src={adjacentPresentations.nextThumb}
              alt={"Tomorrow's lesson"}
              onLoad={() => setLoaded(true)}
            />
          </div>
        )}
        <SVGRightArrow />
      </ButtonElement>
    </>
  )
})

const Actions = injectSheet({
  caret: {
    margin: '0 -2px 0 4px'
  },
  dropMenu: {
    color: 'var(--gray)'
  },
  main: {
    background: 'var(--yellow)',
    color: '#333',
    fontSize: '16px',
    padding: '20px 22px',
    '&:hover': {
      background: 'var(--yellow-)',
      color: '#333'
    }
  },
  secondary: {
    color: 'var(--purple) !important',
    background: 'rgba(255, 255, 255, 0.92) !important',
    border: '1px solid var(--purple--) !important',
    '&:hover': {
      background: '#fff !important',
      color: 'var(--purple) !important'
    }
  },
  crown: {
    fontSize: '10px',
    color: 'var(--yellow)'
  },
  crownBlack: {
    fontSize: '10px',
    color: 'var(--gray)'
  },
  saved: {
    color: 'var(--light-gray) !important',
    '& a': {
      color: 'var(--light-gray)',
      pointerEvents: 'auto'
    }
  },
  container: {
    display: 'flex',
    gap: '16px',
    marginLeft: 'auto',
    '& button': {
      border: 'none',
      boxShadow: 'none',
      '@media (min-width: 768px)': {
        width: 'auto'
      }
    }
  },
  modalPrimary: PARENT_PRIMARY_CTA,
  modalSecondary: {
    color: '#666 !important',
    '&:hover': {
      color: '#666'
    }
  },
  saveModalContent: {
    width: '100%',
    maxWidth: '520px',
    '& h3': {
      margin: '0 0 8px',
      color: 'var(--gray)',
      font: 'var(--heading--)'
    },
    '& p': {
      margin: '0 0 20px',
      color: 'var(--gray--)',
      font: 'var(--body)',
      lineHeight: 1.5
    }
  },
  writingTypeOptions: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    marginBottom: '8px'
  },
  writingTypeOption: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    minHeight: '132px',
    padding: '16px 12px',
    border: '2px solid var(--purple--)',
    borderRadius: '12px',
    background: '#fff',
    color: 'var(--gray)',
    textAlign: 'center',
    cursor: 'pointer',
    transition:
      'border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease',
    '& svg': {
      fontSize: '28px',
      color: 'var(--purple)'
    },
    '& strong': {
      display: 'block',
      font: 'var(--body-)',
      fontWeight: 'bold'
    },
    '& span': {
      font: 'var(--body--)',
      color: 'var(--gray--)',
      lineHeight: 1.4
    },
    '&:hover': {
      borderColor: 'var(--purple)',
      background: '#faf5ff'
    }
  },
  writingTypeOptionSelected: {
    borderColor: 'var(--purple)',
    background: '#faf5ff',
    boxShadow: '0 0 0 2px rgba(129, 95, 165, 0.2)'
  }
})(({ presentation, classes, onSaved, parentWritingId, parentWritingType }) => {
  const [printModalOpen, setPrintModalOpen] = useState(false)
  const [savedStatus, setSavedStatus] = useState(null)
  const [showShareModal, setShowShareModal] = useState(false)
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)
  const [doneWizardOpen, setDoneWizardOpen] = useState(false)
  const [writingPackUpsellOpen, setWritingPackUpsellOpen] = useState(false)
  const [saveModalOpen, setSaveModalOpen] = useState(false)
  const [selectedWritingType, setSelectedWritingType] = useState(null)

  const history = useHistory()
  const {
    handleWritingPackClick,
    writingPackState,
    closeWritingPackModal
  } = useWritingPack({ presentation })

  const { me } = useMe()
  const { hasAccessToTL } = useSubscriptionDetails()

  const posthogActionData = {
    id: presentation.id,
    title: presentation.title,
    category: presentation.category,
    from: 'prompt',
    parent_writing_id: parentWritingId || null,
    parent_writing_type: parentWritingType || null,
    hasAccessToTL,
    role: me.account.role_in_life
  }

  const closeSaveModal = () => {
    if (savedStatus === 'pending') return
    setSaveModalOpen(false)
    setSelectedWritingType(null)
  }

  const saveParentWriting = () => {
    if (!selectedWritingType) {
      toast.error('Please choose how you want to complete this writing.')
      return
    }

    apiClient.post('/v3/me/activated_with_product', {
      type: 'feature'
    })
    posthog.capture('activate', { type: 'feature' })
    posthog.capture('save lesson for parent writing', {
      writing_type: selectedWritingType,
      presentation_id: presentation.id
    })

    setSavedStatus('pending')
    apiClient
      .post(`/v3/parent_writings`, {
        presentation_id: presentation.id,
        writing_type: selectedWritingType
      })
      .then(() => {
        history.push(`/parent/saved`)
      })
      .catch(() => {
        setSavedStatus(null)
      })
      .finally(() => {
        setSaveModalOpen(false)
        setSelectedWritingType(null)
      })
  }

  const selectLesson = (
    <>
      {savedStatus !== 'saved' && (
        <Button
          minw
          pending={savedStatus === 'pending'}
          action={() => setSaveModalOpen(true)}
          className={`${classes.main}`}
          tall
          icon={<FontAwesomeIcon icon={faStar} />}>
          {'Use this prompt'}
        </Button>
      )}
    </>
  )

  return !presentation ? null : (
    <div className={classes.container}>
      <PresentationControls
        presentation={presentation}
        style={{ color: 'var(--purple)' }}
      />
      {/*saveLesson*/}
      {/*shareLesson*/}
      {/*fullScreenButton*/}
      {!parentWritingId && selectLesson}
      {presentation && (
        <>
          <PrintModal
            id={presentation.id}
            isOpen={printModalOpen}
            requestClose={() => setPrintModalOpen(false)}
          />
          {presentation && (
            <ShareModal
              from="prompt"
              presentation={presentation}
              isOpen={showShareModal}
              requestClose={() => setShowShareModal(false)}
            />
          )}
        </>
      )}
      {parentWritingId &&
        parentWritingType === 'uploaded' && (
          <>
            {presentation.p365 && (
              <>
                <Button
                  minw
                  className={classes.secondary}
                  action={() => {
                    handleWritingPackClick()
                    apiClient.post('/v3/me/activated_with_product', {
                      type: 'feature'
                    })
                    posthog.capture('activate', { type: 'feature' })
                    posthog.capture('Share action', {
                      action: 'Writing pack',
                      ...posthogActionData
                    })
                  }}
                  tall
                  icon={
                    <>
                      <FontAwesomeIcon icon={faFileAlt} />
                    </>
                  }>
                  Print writing pack
                </Button>
                <WritingPackModal
                  {...writingPackState}
                  requestClose={closeWritingPackModal}
                />
                <UpsellModal
                  id="writing-pack"
                  isOpen={writingPackUpsellOpen}
                  requestClose={() => setWritingPackUpsellOpen(false)}
                />
              </>
            )}
            <Button
              minw
              className={classes.main}
              action={() => setDoneWizardOpen(true)}
              tall>
              Finish and save
            </Button>
            <ParentWritingDoneWizard
              isOpen={doneWizardOpen}
              requestClose={() => setDoneWizardOpen(false)}
              parentWritingId={parentWritingId}
            />
          </>
        )}
      <UpsellModal
        id={upsellModalOpen}
        isOpen={!!upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
      <Modal isOpen={saveModalOpen} requestClose={closeSaveModal} closeButton>
        <ModalContent className={classes.saveModalContent}>
          <h3>Save this prompt?</h3>
          <p>Choose how your child will complete their writing.</p>
          <div className={classes.writingTypeOptions}>
            <ButtonElement
              type="button"
              className={classNames(classes.writingTypeOption, {
                [classes.writingTypeOptionSelected]:
                  selectedWritingType === 'typed'
              })}
              onClick={() => setSelectedWritingType('typed')}>
              <FontAwesomeIcon icon={faPencil} />
              <strong>Type their writing</strong>
              <span>Write directly on screen</span>
            </ButtonElement>
            <ButtonElement
              type="button"
              className={classNames(classes.writingTypeOption, {
                [classes.writingTypeOptionSelected]:
                  selectedWritingType === 'uploaded'
              })}
              onClick={() => setSelectedWritingType('uploaded')}>
              <FontAwesomeIcon icon={faCamera} />
              <strong>Upload their writing</strong>
              <span>Take a photo of handwritten work</span>
            </ButtonElement>
          </div>
        </ModalContent>
        <ModalFooter alignRight childrenGap>
          <Button
            simple
            tall
            action={closeSaveModal}
            disabled={savedStatus === 'pending'}>
            Cancel
          </Button>
          <Button
            className={classes.modalPrimary}
            minw
            tall
            pending={savedStatus === 'pending'}
            disabled={!selectedWritingType}
            action={saveParentWriting}>
            Save prompt
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
})

export const ParentPrompt = injectSheet({
  pageLayout: {
    width: '100%'
  },
  pageLayoutSplit: {
    display: 'flex',
    alignItems: 'stretch',
    minHeight: 'calc(100vh - 80px)',
    '@media (max-width: 1023px)': {
      flexDirection: 'column'
    }
  },
  container: {
    background: PARENT_PAGE_BG,
    position: 'relative'
  },
  containerSplit: {
    flex: '1 1 58%',
    minWidth: 0
  },
  typingContainer: {
    flex: '1 1 42%',
    minWidth: 0,
    background: '#fff',
    borderLeft: '1px solid var(--purple--)',
    boxShadow: '-8px 0 24px rgba(129, 95, 165, 0.08)',
    padding: '24px 20px',
    position: 'sticky',
    top: '0',
    alignSelf: 'flex-start',
    height: '100vh',
    width: '100%',
    overflowY: 'auto',
    '@media (min-width: 1024px)': {
      padding: '32px 28px'
    },
    '@media (max-width: 1023px)': {
      flex: '1 1 auto',
      borderLeft: 'none',
      borderTop: '1px solid var(--purple--)',
      boxShadow: 'none',
      position: 'relative',
      top: 'auto',
      maxHeight: 'none',
      minHeight: '320px'
    }
  },
  typingTopBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    marginBottom: '16px',
    '& h3': {
      margin: 0,
      font: 'var(--heading--)',
      color: 'var(--purple)'
    }
  },
  typingHint: {
    margin: '0 0 12px',
    color: 'var(--gray--)',
    font: 'var(--body--)'
  },
  typingDoneCTA: {
    ...PARENT_PRIMARY_CTA,
    whiteSpace: 'nowrap'
  },
  editorShell: {
    border: '1px solid var(--purple--)',
    borderRadius: '12px',
    background: '#fff',
    overflow: 'hidden'
  },
  editorToolbar: {
    fontSize: '22px',
    padding: '8px 10px',
    borderBottom: '1px solid #ececec',
    background: '#faf5ff'
  },
  editorInput: {
    '& .public-DraftEditor-content': {
      minHeight: '340px',
      border: 'none !important',
      borderRadius: 0,
      padding: '16px',
      color: '#374151',
      font: 'var(--body)',
      lineHeight: 1.6
    }
  },
  typingFooter: {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px'
  },
  typingStatus: {
    margin: 0,
    color: 'var(--gray---)',
    font: 'var(--body---)'
  },
  typingModalContent: {
    width: '100%',
    maxWidth: '460px',
    textAlign: 'center',
    '& h3': {
      margin: '0 0 10px',
      color: '#111827',
      font: 'var(--heading--)'
    },
    '& p': {
      margin: 0,
      color: '#4b5563',
      font: 'var(--body)'
    }
  },
  heroSection: {
    position: 'relative',
    marginTop: '-140px',
    '@media (min-width: 768px)': {
      marginTop: '-80px'
    },
    '@media (max-width: 1023px)': {
      height: 'calc(100vh - 140px) !important'
    },
    '@supports (-webkit-touch-callout: none)': {
      height: 'calc(100vh - 220px) !important'
    }
  },
  heroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  heroFooter: {
    color: '#fff',
    position: 'absolute',
    bottom: '0',
    width: '100%',
    background: PARENT_HERO_GRADIENT_BOTTOM,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  },
  scroll: {
    backgroundColor: 'rgba(255, 255, 255, .1)',
    border: '2px solid rgba(255, 255, 255, .5)',
    borderRadius: '16px',
    height: '52px',
    width: '32px',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
    opacity: '0',
    transform: 'translateY(-4px)',
    animation: '.3s appear .2s ease-out forwards',
    '& svg': {
      fill: 'rgba(255, 255, 255, .5)',
      width: '14px',
      height: '14px',
      animation: 'scroll 3.9s infinite'
    },
    '&:hover': {
      borderColor: '#fff',
      '& svg': {
        fill: '#fff'
      }
    }
  },
  title: {
    margin: '0 0 16px',
    textAlign: 'center',
    font: 'var(--heading)',
    opacity: '0',
    transform: 'translateY(8px)',
    animation: 'appear .3s ease-out forwards'
  },
  play: {
    opacity: 0,
    transform: 'translateY(8px)',
    animation: '.3s appear .2s ease-out forwards',
    marginBottom: '16px'
  },
  snippet: {
    margin: '-4px 0 16px',
    textAlign: 'center',
    color: 'var(--light-gray)',
    opacity: '0',
    font: 'var(--body)',
    transform: 'translateY(8px)',
    animation: '.3s appear .2s ease-out forwards'
  },
  activities: {
    padding: '0 20px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    '@media (min-width: 1024px)': {
      padding: '0 56px 56px'
    }
  },
  activitiesHeader: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '38px 0 56px',
    gap: '24px',
    textAlign: 'center',
    color: 'var(--gray)',
    '& img': {
      margin: '32px 0',
      width: '260px',
      objectFit: 'cover',
      objectPosition: 'center',
      filter: 'invert(0.4)'
    },
    '& h3': {
      margin: '0',
      font: 'var(--heading)',
      color: 'var(--purple)'
    }
  },
  slide: {
    marginBottom: '32px',
    position: 'relative',
    '@media (min-width: 1024px)': {
      marginBottom: '64px'
    }
  },
  slideRestricted: {
    opacity: '0.5',
    filter: 'blur(5px)',
    userSelect: 'none',
    '& > *': {
      pointerEvents: 'none'
    }
  },
  slideRestrictedCTA: {
    top: '50%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    maxWidth: '60%',
    minHeight: '60px'
  },
  slideHolder: {
    borderRadius: '8px',
    overflow: 'hidden'
  },
  editButton: {
    color: 'var(--purple) !important',
    font: 'var(--heading--)',
    marginBottom: '4px',
    '& > div': {
      height: '14px'
    }
  },
  main: {
    background: '#fff',
    color: 'var(--gray)',
    '&:hover': {
      background: '#fff',
      color: '#000'
    }
  },
  secondary: {
    background: 'none',
    color: 'var(--light-gray)',
    border: '1px solid var(--light-gray) !important',
    '&:hover': {
      background: 'none',
      color: 'var(--light-gray)'
    }
  },
  accentButton: PARENT_PRIMARY_CTA,
  simpleButton: {
    background: 'none !important',
    color: 'var(--purple)',
    border: 'none'
  },
  resources: {
    paddingRight: '0',
    '@media (min-width: 768px)': {
      paddingRight: '15px'
    }
  },
  explore: {
    display: 'flex',
    alignItems: 'center !important',
    font: 'var(--body-)',
    marginLeft: 'auto'
  },
  tagLine: {
    color: 'var(--gray)',
    marginRight: '4px',
    display: 'none',
    '@media (min-width: 769px)': {
      display: 'block'
    }
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateY(-4px)',
    animation: '.5s appear .4s forwards',
    opacity: '0',
    '& button': {
      margin: '0 0 16px !important'
    },
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      '& button': {
        margin: '0 16px 0 0 !important'
      }
    }
  },
  myPrompt: {
    background: 'none !important',
    color: 'var(--purple)',
    border: 'none',
    padding: '12px 15px',
    fontWeight: 'bold',
    marginLeft: '8px',
    '& svg': {
      marginRight: '6px',
      fontSize: '.8em'
    },
    '& a': {
      textDecoration: 'underline',
      color: 'var(--purple)'
    }
  },
  info: {
    margin: '8px 0',
    font: 'var(--body)',
    opacity: '0',
    transform: 'translateY(8px)',
    animation: '.3s appear .1s ease-out forwards',
    color: 'var(--yellow)',
    fontWeight: 'bold'
  },
  builder: {
    width: '100%',
    padding: '2% 10% 8%',
    background: 'rgba(255, 255, 255, 0.85)',
    borderRadius: '8px',
    border: '2px solid transparent',
    '& > *': {
      pointerEvents: 'none'
    },
    '&:hover': {
      borderColor: 'var(--blue)'
    },
    '&:focus': {
      borderColor: '#fff'
    },
    '&:active': {
      borderColor: '#fff'
    },
    '& img': {
      display: 'block',
      maxWidth: '100%'
    },
    '& > span': {
      fontSize: '24px',
      lineHeight: '1.2',
      display: 'block',
      textAlign: 'center',
      color: '#fff',
      fontWeight: 'bold',
      '@media (min-width: 768px)': {
        fontSize: '56px'
      }
    }
  },
  yellow: {
    color: 'var(--yellow)'
  },
  calendarButton: {
    '& span': {
      display: 'none',
      '@media (min-width: 1024px)': {
        display: 'inline'
      }
    }
  },
  headerHolder: {
    display: 'flex',
    width: '100%',
    maxWidth: '1200px',
    padding: '20px 20px',
    margin: '0 auto',
    '@media (min-width: 1024px)': {
      padding: '20px 56px'
    }
  },
  headerDifficulty: {
    display: 'none',
    filter: 'invert(1) hue-rotate(-160deg)',
    '@media (min-width: 768px)': {
      display: 'block'
    }
  },
  actionsHolder: {
    marginLeft: 'auto'
  },
  separator: {
    width: '1px',
    height: '16px',
    background: 'var(--purple--)',
    display: 'none',
    '@media (min-width: 1024px)': {
      display: 'block'
    }
  },
  saved: {
    animation: 'fadeFromYellow 1s ease-out'
  },
  restrictedFooter: {
    background: PARENT_HERO_GRADIENT_BOTTOM
  },
  restricted: {
    marginTop: '16px',
    paddingTop: '24px',
    padding: '8px 0',
    font: 'var(--body)',
    fontWeight: 'bold',
    '& p': {
      margin: '0'
    },
    '@media (min-width: 768px)': {
      borderTop: '1px solid rgba(255, 255, 255, .3)'
    }
  },
  restrictedPadding: {
    height: '20px'
  },
  restrictedHolder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    opacity: '0',
    transform: 'translateY(-4px)',
    animation: '.6s appear .3s ease-out forwards',
    textAlign: 'center',
    maxWidth: '230px',
    '@media (min-width: 768px)': {
      maxWidth: 'none'
    }
  },
  restrictedDate: {
    color: 'var(--yellow)'
  },
  restrictedActivitiesMessage: {
    font: 'var(--body--)',
    fontWeight: 'normal',
    margin: '32px 0 16px !important',
    textAlign: 'center'
  },
  mainDiffSelector: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '8px',
    '& ul': {
      filter: 'invert(1) hue-rotate(-160deg)'
    },
    '& p': {
      font: 'var(--body-)'
    }
  },
  fixedHeader: {
    position: 'absolute',
    height: '80px',
    padding: '20px',
    zIndex: '10',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    '& > div': {
      opacity: '0',
      transform: 'translateY(4px)',
      animation: '.3s appear .5s ease-out forwards'
    }
  },
  panelCTATest: PARENT_PRIMARY_CTA,
  middleCTA: {
    '& > *': {
      border: 'none'
    }
  },
  ftPromptCTA: {
    color: '#fff !important',
    fontSize: '16px',
    border: '1px solid #fff',
    marginBottom: '30px'
  },
  emailMeCTA: {
    fontSize: '18px',
    padding: '24px 30px',
    ...PARENT_PRIMARY_CTA,
    color: '#fff !important'
  },
  sponsoredLogo: {
    background: '#fff',
    outline: '4px solid #fff',
    marginTop: '8px'
  },
  '@keyframes appear': {
    to: {
      transform: 'translateY(0)',
      opacity: '1'
    }
  },
  '@keyframes fadeFromYellow': {
    from: {
      background: 'rgba(254, 228, 51, 1)'
    },
    to: {
      background: 'rgba(254, 228, 51, 0)'
    }
  },
  '@keyframes scroll': {
    '0%': {
      transform: 'translateY(-12px)',
      opacity: 0
    },
    '20%': {
      transform: 'translateY(8px)',
      opacity: 1
    },
    '80%': {
      transform: 'translateY(8px)',
      opacity: 1
    },
    '85%': {
      opacity: 1
    },
    '97%': {
      opacity: 0
    },
    to: {
      transform: 'translateY(44px)',
      opacity: 0
    }
  }
})(({ classes, presentationId, parentWritingId }) => {
  const history = useHistory()
  const {
    writingType: parentWritingType,
    workVersion,
    isLoading: isParentWritingLoading
  } = useParentWriting(parentWritingId)
  const [presentation, setPresentation] = useState(null)
  const [todayPresentationId, setTodayPresentationId] = useState(null)
  const slidesContainerRef = useRef(null)
  const { id: routeId } = useParams()
  const id = presentationId || routeId
  const [editUpsellOpen, setEditUpsellOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const freePromptIds = useFreePrompts()

  const {
    difficultySelector,
    selectedPresentation,
    isDifferentiated
  } = useDifficultyLevels({
    presentation,
    includeString: DEFAULT_INCLUDE,
    levelLabels: ['✏️', '✏️✏️', '✏️✏️✏️']
  })

  const allDataLoaded = !!presentation && !!freePromptIds

  const { hasAccessToTL } = useSubscriptionDetails()
  const { me } = useMe()

  const studentWithoutSub =
    me.account.role_in_life === 'student' && !hasAccessToTL

  /*const restrictedPrompt =
    presentation &&
    !presentation.sponsored &&
    !hasAccessToTL &&
    !!freePromptIds &&
    !freePromptIds.has(presentation.id)*/

  // Todo: Remove after QA
  const restrictedPrompt = false

  const [yearGroups, setYearGroups] = useState(null)

  const date = useMemo(
    () => {
      if (presentation) {
        if (presentation.p365_month && presentation.p365_day) {
          const monthIndex = presentation.p365_month - 1
          const dateString = `${YEAR}-${presentation.p365_month}-${
            presentation.p365_day
          }`

          const weekdayIndex = (getWeekday(dateString) + 6) % 7

          return `${daysOfWeek[weekdayIndex]}, ${months[monthIndex]} ${
            presentation.p365_day
          }`
        }
      }
    },
    [presentation]
  )

  /**
   * Fetch yearGroups
   */
  useEffect(() => {
    apiClient
      .get('v3/year_groups', {
        params: {
          include: 'include=year_group.names,year_group.order'
        }
      })
      .then(res => {
        setYearGroups(res.data.year_groups)
      })
  }, [])

  const yearGroup = useMemo(
    () => {
      if (!yearGroups || !presentation) return null
      return yearGroups.filter(
        yg => yg.id === presentation.year_groups[0].id
      )[0]
    },
    [yearGroups, presentation]
  )

  /**
   * Show a toast message for users who got redirected
   *  after buying a subscription
   */
  useEffect(
    () => {
      if (!!window.location.href.match(/id=.*&state=succeeded/)) {
        toast.success('Thanks for subscribing!')
        posthog.capture('subscribed', me.account.individual_subscription)

        /**
         * Keep it for 500ms for hotjar to capture the URL
         *  so we can filter out recordings with users
         *  who bought a sub
         */
        setTimeout(() => {
          window.history.replaceState &&
            window.history.replaceState(null, null, window.location.pathname)
        }, 500)
      }
    },
    [me.account.individual_subscription]
  )

  useEffect(
    () => {
      setPresentation(null)
      setEmailMeStatus(null)

      if (id) {
        apiClient
          .get(`/v3/presentations/${id}`, {
            params: { include: DEFAULT_INCLUDE }
          })
          .then(res => setPresentation(res.data.presentation))
        if (!todayPresentationId) {
          apiClient
            .get('/v3/p365/today', {
              params: {
                count: 1,
                from: 0
              }
            })
            .then(res => {
              setTodayPresentationId(res.data.presentations[0].id)
            })
        }
      } else {
        apiClient
          .get('/v3/p365/today', {
            params: {
              count: 1,
              from: 0,
              include: DEFAULT_INCLUDE
            }
          })
          .then(res => {
            const presentation = res.data.presentations[0]
            setPresentation(presentation)
            setTodayPresentationId(presentation.id)
          })
      }
    },
    [id] // eslint-disable-line
  )

  useEffect(
    () => {
      const handleScroll = () => {
        if (
          window.innerHeight + window.scrollY >=
          document.documentElement.scrollHeight
        ) {
          if (!restrictedPrompt && presentation) {
            apiClient.post('/v3/me/activated_with_product', {
              type: 'content'
            })
            posthog.capture('activate', { type: 'content' })
            posthog.capture('Scrolled to the bottom of the prompt (v2)', {
              lesson_category: presentation.category || null,
              lesson_id: presentation.id || null,
              lesson_title: presentation.title || null
            })
          }

          window.removeEventListener('scroll', handleScroll)
        }
      }

      window.addEventListener('scroll', handleScroll)
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    },
    [presentation, restrictedPrompt]
  )

  const [upsellModalOpen, setUpsellModalOpen] = useState(false)
  const [emailMeStatus, setEmailMeStatus] = useState(null)
  const showTypingPanel =
    parentWritingType === 'typed' &&
    !!parentWritingId &&
    !isParentWritingLoading
  const [workVersionId, setWorkVersionId] = useState(null)
  const [typingEditorState, setTypingEditorState] = useState(() =>
    EditorState.createEmpty()
  )
  const [typingState, setTypingState] = useState('idle')
  const [doneModalOpen, setDoneModalOpen] = useState(false)
  const [submitPending, setSubmitPending] = useState(false)
  const lastSavedHtmlRef = useRef('')

  useEffect(
    () => {
      if (!showTypingPanel || !workVersion || !workVersion.id) {
        setWorkVersionId(null)
        setTypingEditorState(EditorState.createEmpty())
        setTypingState('idle')
        lastSavedHtmlRef.current = ''
        return
      }

      const existingBody = getTypedBodyFromWorkVersion(workVersion)
      setWorkVersionId(workVersion.id)
      setTypingEditorState(
        existingBody
          ? createStateFromHtml(existingBody)
          : EditorState.createEmpty()
      )
      lastSavedHtmlRef.current = existingBody || ''
    },
    [showTypingPanel, workVersion]
  )

  useEffect(
    () => {
      if (!showTypingPanel || !workVersionId || submitPending) return

      const timer = setInterval(() => {
        const html = stateToHTML(typingEditorState)
        if (!hasMeaningfulBody(html) || html === lastSavedHtmlRef.current) {
          return
        }

        setTypingState('saving')
        apiClient
          .post(
            `/v3/parent_writing_work_versions/${workVersionId}/cache_typed_body`,
            {
              body: html
            }
          )
          .then(() => {
            lastSavedHtmlRef.current = html
            setTypingState('saved')
          })
          .catch(() => {
            setTypingState('error')
          })
      }, 1000)

      return () => clearInterval(timer)
    },
    [showTypingPanel, submitPending, typingEditorState, workVersionId]
  )

  const submitTypedWork = () => {
    if (!parentWritingId || !workVersionId) return

    const html = stateToHTML(typingEditorState)
    if (!hasMeaningfulBody(html)) {
      toast.error('Please add some writing before marking this as done.')
      return
    }

    posthog.capture('submit parent writing', {
      writing_type: 'typed'
    })

    setSubmitPending(true)
    apiClient
      .post(`/v3/parent_writing_work_versions/${workVersionId}/type_medium`, {
        body: html
      })
      .then(() => {
        return apiClient.put(`/v3/parent_writings/${parentWritingId}/mark_done`)
      })
      .then(() => {
        toast.success('Writing saved and marked as done.')
        history.push('/parent/saved')
      })
      .catch(errorHandler)
      .finally(() => {
        setSubmitPending(false)
        setDoneModalOpen(false)
      })
  }

  return (
    <PromptsLayout showSidebar={false}>
      <div
        className={classNames(classes.pageLayout, {
          [classes.pageLayoutSplit]: showTypingPanel
        })}>
        <div
          className={classNames(classes.container, {
            [classes.containerSplit]: showTypingPanel
          })}>
          {/*<Nav presentation={presentation} />*/}
          <header className={classes.fixedHeader}>
            {parentWritingId &&
              allDataLoaded &&
              !restrictedPrompt && <ParentBackToWriting />}
            {allDataLoaded &&
              !restrictedPrompt && (
                <Actions
                  key={selectedPresentation.id}
                  presentation={selectedPresentation}
                  parentWritingId={parentWritingId}
                  parentWritingType={parentWritingType}
                />
              )}
          </header>
          {(!parentWritingId ||
            isParentWritingLoading ||
            parentWritingType !== 'typed') && (
            <HeroHeader>
              {({ scrolledPastHero }) => (
                <div
                  className={classes.headerHolder}
                  style={!allDataLoaded ? { pointerEvents: 'none' } : null}>
                  {allDataLoaded &&
                    !restrictedPrompt && (
                      <>
                        {scrolledPastHero && (
                          <>
                            {!parentWritingId && (
                              <div className={classes.headerDifficulty}>
                                {difficultySelector}
                              </div>
                            )}
                            {parentWritingId && <ParentBackToWriting />}
                            <div className={classes.actionsHolder}>
                              <Actions
                                key={selectedPresentation.id}
                                presentation={selectedPresentation}
                                parentWritingId={parentWritingId}
                                parentWritingType={parentWritingType}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                </div>
              )}
            </HeroHeader>
          )}
          {!parentWritingId && (
            <section className={`h-screen-header ${classes.heroSection}`}>
              {allDataLoaded && (
                <>
                  <Image
                    onContextMenu={e => {
                      e.preventDefault()
                    }}
                    className={classes.heroImage}
                    src={presentation.image && presentation.image.url}
                    alt={selectedPresentation.title}
                  />
                  <footer
                    className={classNames(classes.heroFooter, {
                      [classes.restrictedFooter]: restrictedPrompt
                    })}>
                    {!restrictedPrompt && (
                      <ButtonElement
                        onClick={() => {
                          window.scrollTo({
                            top: window.innerHeight - 40,
                            behavior: 'smooth'
                          })
                        }}
                        className={`${
                          classes.scroll
                        } metrics__prompt_scroll_button`}>
                        <SvgScrollArrow />
                      </ButtonElement>
                    )}

                    {presentation.p365 &&
                      !restrictedPrompt && (
                        <p className={classes.info}>{date}</p>
                      )}
                    {presentation.category === 'theme_based' &&
                      yearGroup && (
                        <p className={classes.info}>
                          Age {yearGroup.from}-{yearGroup.to}
                        </p>
                      )}

                    <h2 className={classes.title}>
                      {selectedPresentation.title}
                    </h2>
                    {!!presentation.p365 &&
                      !!selectedPresentation.slides[3] &&
                      !!selectedPresentation.slides[3].text && (
                        <>
                          <p className={classes.snippet}>
                            {selectedPresentation.slides[3].text.slice(0, 64)}...
                          </p>
                        </>
                      )}
                    {restrictedPrompt && (
                      <div className={classes.restricted}>
                        <div className={classes.restrictedHolder}>
                          {presentation.p365_day && (
                            <p>
                              Free on{' '}
                              <strong className={classes.restrictedDate}>
                                {date}
                              </strong>
                            </p>
                          )}
                          {emailMeStatus !== 'reminded' && (
                            <Button
                              className={`metrics__prompt_panel--email ${
                                classes.emailMeCTA
                              }`}
                              tall
                              pending={emailMeStatus === 'pending'}
                              simple
                              onClick={() => {
                                posthog.capture(
                                  'clicked on remind me via email cta from prompt',
                                  {
                                    lesson_category: presentation.category,
                                    lesson_id: presentation.id,
                                    lesson_title: presentation.title
                                  }
                                )
                                setEmailMeStatus('pending')
                                apiClient
                                  .post(
                                    `/v3/presentations/${
                                      presentation.id
                                    }/remind_when_free`
                                  )
                                  .then(res => {
                                    setEmailMeStatus('reminded')
                                  })
                                  .catch(e => {
                                    if (getErrorInfo(e).status === 400) {
                                      setEmailMeStatus('reminded')
                                    } else {
                                      errorHandler(e)
                                    }
                                  })
                              }}>
                              Email me when this prompt is free
                            </Button>
                          )}
                          {emailMeStatus === 'reminded' && (
                            <Button
                              icon={<FontAwesomeIcon icon={faCheck} />}
                              className={`metrics__prompt_panel--email ${
                                classes.emailMeCTA
                              }`}
                              tall
                              disabled
                              simple>
                              Done. We'll email you on {date} when this prompt
                              is free.
                            </Button>
                          )}
                          {!studentWithoutSub && (
                            <>
                              <span>or</span>
                              <Button
                                className={`metrics__prompt_panel ${
                                  classes.ftPromptCTA
                                }`}
                                tall
                                simple
                                onClick={() => {
                                  posthog.capture(
                                    'triggers upsell modal from prompt',
                                    {
                                      lesson_category: presentation.category,
                                      lesson_id: presentation.id,
                                      lesson_title: presentation.title
                                    }
                                  )
                                  setModalOpen(true)
                                }}>
                                Start a free trial to access it now
                              </Button>
                            </>
                          )}
                          <div className={classes.slideDeck}>
                            <SlidesDeck presentation={presentation} />
                            {presentation.p365_day ? (
                              <p
                                className={classes.restrictedActivitiesMessage}>
                                Includes {presentation.slides.length - 4}{' '}
                                writing activities
                              </p>
                            ) : (
                              <p style={{ height: 48 }} />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </footer>
                </>
              )}
            </section>
          )}
          {restrictedPrompt ? (
            <div className={classes.restrictedPadding} />
          ) : (
            <section className={classes.activities}>
              {presentation && (
                <div ref={slidesContainerRef} className={classes.slidesHolder}>
                  <header className={classes.activitiesHeader}>
                    {!parentWritingId && (
                      <img
                        src={wiggleBorder}
                        alt="wiggle border"
                        width={530}
                        height={15}
                      />
                    )}
                    <h3>
                      Writing activities for &ldquo;{presentation.title}&rdquo;
                    </h3>
                    {parentWritingId && (
                      <p>Read the story starter, then pick your activity.</p>
                    )}
                    {isDifferentiated &&
                      !parentWritingId && (
                        <div className={classes.mainDiffSelector}>
                          <p>
                            Select the difficulty level for these writing
                            activities
                          </p>
                          {difficultySelector}
                        </div>
                      )}
                  </header>
                  <Presentation
                    containerRef={slidesContainerRef}
                    multiSlides
                    data={selectedPresentation}>
                    {({ slides }) => {
                      const sliceFrom =
                        presentation.category === 'quick_writes' ? 2 : 3
                      return slides
                        .slice(sliceFrom, slides.length)
                        .map((slide, i) => ({
                          slide,
                          slideData: selectedPresentation.slides[i + sliceFrom],
                          slideIndex: i + sliceFrom
                        }))
                        .filter(
                          ({ slideData }) =>
                            slideData.available_for_parents === true
                        )
                        .map(({ slide, slideIndex }) => {
                          return (
                            <Fragment key={slideIndex}>
                              <div className={classes.slide}>
                                <div className={classes.slideHolder}>
                                  {slide}
                                </div>
                              </div>
                              {slideIndex === 3 && <ParentHowToUsePanel />}
                            </Fragment>
                          )
                        })
                    }}
                  </Presentation>
                  <UpsellModal
                    id="slide"
                    isOpen={upsellModalOpen}
                    requestClose={() => setUpsellModalOpen(false)}
                  />
                </div>
              )}
            </section>
          )}
          <EditUpsell
            isOpen={editUpsellOpen}
            requestClose={() => setEditUpsellOpen(false)}
          />
          <UpsellModal
            id="panel"
            isOpen={modalOpen}
            requestClose={() => setModalOpen(false)}
          />
        </div>
        {showTypingPanel && (
          <aside className={classes.typingContainer}>
            <div className={classes.typingTopBar}>
              <h3>Your writing</h3>
              <Button
                className={classes.typingDoneCTA}
                minw
                tall
                action={() => setDoneModalOpen(true)}
                pending={submitPending}>
                Finish and save
              </Button>
            </div>
            <p className={classes.typingHint}>You can type here below.</p>
            <div className={classes.editorShell}>
              <EditorProvider
                editorState={typingEditorState}
                onChange={setTypingEditorState}>
                <Controls.Panel className={classes.editorToolbar}>
                  <Controls.Bold />
                  <Controls.Italic />
                  <Controls.Underline />
                  <Controls.Separator />
                  <Controls.OrderedList />
                  <Controls.UnorderedList />
                </Controls.Panel>
                <Editor className={classes.editorInput} placeholder={false} />
              </EditorProvider>
            </div>
            <div className={classes.typingFooter}>
              <p className={classes.typingStatus}>
                {typingState === 'saving' && 'Saving...'}
                {typingState === 'saved' && 'Saved'}
                {typingState === 'error' && 'Could not auto-save just now'}
                {typingState === 'idle' && 'Your typing is auto-saved'}
              </p>
            </div>
            <Modal
              isOpen={doneModalOpen}
              requestClose={() => {
                if (submitPending) return
                setDoneModalOpen(false)
              }}
              closeButton>
              <ModalContent className={classes.typingModalContent}>
                <h3>Finished for now?</h3>
                <img width="320" src={finished} alt="Pobble Home" />
                <p>Nice work! When you're ready, mark it as done.</p>
              </ModalContent>
              <ModalFooter alignRight childrenGap>
                <Button
                  simple
                  tall
                  action={() => setDoneModalOpen(false)}
                  disabled={submitPending}>
                  Cancel
                </Button>
                <Button
                  className={classes.typingDoneCTA}
                  minw
                  tall
                  pending={submitPending}
                  action={submitTypedWork}>
                  Save and finish
                </Button>
              </ModalFooter>
            </Modal>
          </aside>
        )}
      </div>
    </PromptsLayout>
  )
})
